export const getLongestLabel = <T>(
  staticOptions: T[],
  labelAccessor: (d: T) => string,
  keyAccessor: (d: T) => string,
) => {
  const longestLabel = staticOptions.reduce(
    (acc, option) => {
      const label = labelAccessor(option);
      if (label.length > acc.length) {
        return { length: label.length, id: keyAccessor(option) };
      }
      return acc;
    },
    { length: 0, id: '' },
  );

  return longestLabel.length > 0 ? longestLabel.id : null;
};
